// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"dxTmJ_o8AJ7T2V9L7QyfE"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Form/LoginForm/LoginForm.css
// module id = 1320
// module chunks = 0